import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import stripAttr from 'strip-attributes'
import textReplace from 'utils/textReplace'

import styles from './Section.module.css'

const SectionParagraph = ({ text }) => {
  const markup = stripAttr(textReplace(text.value), { omit: ['style'] })

  return <h2 className={styles.wrapper} dangerouslySetInnerHTML={{ __html: markup }}></h2>
}

SectionParagraph.propTypes = {
  text: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }),
}

const fragments = {
  paragraph: gql`
    fragment SectionParagraphFragment on ParagraphNodeSection {
      id
      text: fieldText {
        value
      }
      avaliableTeacherOnly: fieldAvailableTeacherOnly
      layoutSectionAffect: fieldLayoutSectionAffect
    }
  `,
}

export { SectionParagraph, fragments }
